export class WebhookV1StandardPayloadMpaReview {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadMpaReviewTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadMpaReviewArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadMpaReview.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadMpaReviewTypeEnum;
(function (WebhookV1StandardPayloadMpaReviewTypeEnum) {
    WebhookV1StandardPayloadMpaReviewTypeEnum["Approved"] = "MPA_REQUEST_APPROVED";
    WebhookV1StandardPayloadMpaReviewTypeEnum["Denied"] = "MPA_REQUEST_DENIED";
    WebhookV1StandardPayloadMpaReviewTypeEnum["PartiallyApproved"] = "MPA_REQUEST_PARTIALLY_APPROVED";
})(WebhookV1StandardPayloadMpaReviewTypeEnum || (WebhookV1StandardPayloadMpaReviewTypeEnum = {}));
